import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bottom-dialog',
  templateUrl: './bottom-dialog.component.html',
  styleUrls: ['./bottom-dialog.component.scss'],
  standalone: false
})
export class BottomDialogComponent {
  
  @Input() isVisible: boolean = false;
  @Input() size: 'normal' | 'large' = 'normal';
  @Input() iconName: string | null = null;

  @Input() closeOnOutsideClick: boolean = true;

  @Input() title?: string;
  @Output() actionCancelled: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  handleOutsideClick() {
    if (this.closeOnOutsideClick) {
      this.actionCancelled.emit();
    }
  }

  handleCloseClick() {
    this.actionCancelled.emit();
  }
}